import React from 'react'
import clsx from 'clsx'

import Tooltip from '../Tooltip'

import useStyles from './styles'

const OverflowTooltip = ({
  hideTT = false,
  text = undefined,
  children,
  className = undefined,
  ...props
}) => {
  const elemRef = React.useRef()

  const classes = useStyles()

  let elem = (
    <div ref={elemRef} className={clsx(classes.root, className)} {...props}>
      {children}
    </div>
  )

  // Show tooltip if text is overflowing
  if (elemRef.current) {
    const element = elemRef.current
    if (!hideTT || element.offsetWidth < element.scrollWidth) {
      elem = (
        <Tooltip
          title={text ? `${children}: ${text}` : children}
          placement='left'
          arrow
        >
          {elem}
        </Tooltip>
      )
    }
  }

  return elem
}

export default OverflowTooltip
